import { ArrowIcon } from '@wbk/svg';
import { Button, ImageWithPlaceholder, Typography } from '@wbk/ui';
import { twMerge } from 'tailwind-merge';

interface FunCardProps {
  buttonText: string;
  imageUrl: string;
  imageAlt: string;
  className?: string;
  onButtonClick?: () => void;
}

const FunCard = ({
  imageUrl,
  imageAlt = 'Event image',
  buttonText = 'Get Tickets',
  onButtonClick,
  className,
}: FunCardProps) => {
  return (
    <div
      className={twMerge(
        'group relative h-full w-full overflow-hidden rounded-2xl md:rounded-3xl dark:bg-black dark:text-[#F4F4F5]',
        className
      )}
    >
      {/* Background Image */}
      <div className='relative h-full'>
        <ImageWithPlaceholder
          src={imageUrl}
          alt={imageAlt}
          className='h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110'
          draggable={false}
        />

        <div className='absolute inset-x-0 bottom-0 flex flex-col gap-1 p-2 sm:p-4'>
          <Button
            onClick={onButtonClick}
            className='sm:text-body-S flex items-center justify-between gap-2 !rounded-full bg-[#0000004D] p-2 text-xs font-semibold backdrop-blur-[10px] transition-colors hover:bg-[#0000004D]/20 active:bg-[#0000004D]/20 sm:p-4'
          >
            <Typography className='text-body-XXS sm:text-body-M flex items-center gap-1 text-nowrap font-semibold'>
              {buttonText}
            </Typography>
            <ArrowIcon className='size-2 sm:size-4 lg:size-6 ltr:rotate-180' />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FunCard;
